export const getAssetLibraryLandingPageContentStyle = () => ({
  container: {
    '& .asset-library-toolbar': {
      '& .navbar-nav': {
        margin: 0,
      },
    },
    '& .asset-library-grid-container': {
      marginTop: 12,
      position: 'relative',
    },
    '& .asset-library-sort-option': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
  },
  emptyViewContainer: {
    '& .empty-view-container': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',

      '& .empty-view-title': {
        fontWeight: 500,
        fontSize: 20,
        lineHeight: '24px',
        color: '#212121',
      },

      '& .empty-view-desc': {
        marginTop: 16,
        maxWidth: 350,
        fontWeight: 400,
        fontSize: 16,
        lineHeight: '24px',
        color: '#6E6E6E',
        textAlign: 'center',
      },
    },
  },
});

